// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container principal avec marge pour la sidebar - Cohérence avec les autres interfaces */
.users-page {
  /* margin-left: 230px; */
  padding: 2rem;
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 50%, #f5f7fa 100%);
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.users-page h1 {
  color: #1e293b;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 50%, #3b82f6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Header avec filtres et bouton d'ajout */
.users-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  gap: 1rem;
  flex-wrap: wrap;
}

.users-filters {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

.users-filters select,
.users-filters input {
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.875rem;
  background: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  min-width: 140px;
}

.users-filters input {
  min-width: 200px;
}

.users-filters select:focus,
.users-filters input:focus {
  outline: none;
  border-color: #7c3aed;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
  transform: translateY(-1px);
}

.users-filters input::placeholder {
  color: #94a3b8;
}

/* Bouton d'ajout */
.users-btn-add {
  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%);
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);
  white-space: nowrap;
}

.users-btn-add:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(124, 58, 237, 0.4);
}

.users-btn-add:active {
  transform: translateY(0);
}

/* Tableau */
.users-table {
  width: 100%;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border-collapse: collapse;
}

.users-table thead {
  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 50%, #8b5cf6 100%);
}

.users-table thead th {
  padding: 1.25rem 1rem;
  text-align: left;
  font-weight: 600;
  color: white;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.users-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.users-table tbody tr:hover {
  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);
  transform: scale(1.005);
}

.users-table tbody tr:last-child {
  border-bottom: none;
}

.users-table tbody td {
  padding: 3px;
  color: #374151;
  font-size: 0.875rem;
  vertical-align: middle;
}

/* Styles pour les rôles */
.role {
  padding: 0.375rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-block;
  transition: all 0.2s ease;
}

.role.admin {
  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(124, 58, 237, 0.3);
}

.role.tech {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

/* Boutons d'action */
.users-btn-edit,
.users-btn-delete {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6b7280;
  margin: 0 0.25rem;
}

.users-btn-edit:hover {
  background: #dbeafe;
  color: #3b82f6;
  transform: scale(1.1);
}

.users-btn-delete:hover {
  background: #fee2e2;
  color: #ef4444;
  transform: scale(1.1);
}

/* Modal overlay */
.users-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
  animation: users-modal-fade-in 0.3s ease;
}

@keyframes users-modal-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal */
.users-modal {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: users-modal-slide-up 0.3s ease;
}

@keyframes users-modal-slide-up {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.users-modal h2 {
  color: #1e293b;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  text-align: center;
  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 50%, #3b82f6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Formulaire modal */
.users-modal form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.users-modal input,
.users-modal select {
  padding: 0.875rem;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: white;
}

.users-modal input:focus,
.users-modal select:focus {
  outline: none;
  border-color: #7c3aed;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
  transform: translateY(-1px);
}

.users-modal input::placeholder {
  color: #9ca3af;
}

/* Actions de modal */
.users-modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.users-modal-actions button {
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  flex: 1 1;
}

.users-modal-actions button[type="submit"] {
  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);
}

.users-modal-actions button[type="submit"]:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(124, 58, 237, 0.4);
}

.users-modal-actions button[type="button"] {
  background: #f3f4f6;
  color: #374151;
}

.users-modal-actions button[type="button"]:hover {
  background: #e5e7eb;
  transform: translateY(-1px);
}

/* Message "Aucun utilisateur trouvé" */
.users-table tbody td[colspan="6"] {
  text-align: center;
  color: #6b7280;
  font-style: italic;
  padding: 2rem;
  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
}

/* Responsive */
@media (max-width: 1024px) {
  .users-page {
    margin-left: 0;
    padding: 1rem;
  }
}

@media (max-width: 768px) {
  .users-header {
    flex-direction: column;
    align-items: stretch;
  }

  .users-filters {
    justify-content: center;
    flex-wrap: wrap;
  }

  .users-filters select,
  .users-filters input {
    min-width: auto;
    flex: 1 1;
  }

  .users-table {
    font-size: 0.75rem;
  }

  .users-table thead th,
  .users-table tbody td {
    padding: 0.75rem 0.5rem;
  }

  .users-modal {
    padding: 1.5rem;
    margin: 1rem;
  }

  .users-modal-actions {
    flex-direction: column;
  }

  .users-modal-actions button {
    flex: none;
  }
}

@media (max-width: 480px) {
  .users-page h1 {
    font-size: 2rem;
  }

  .users-table thead th {
    font-size: 0.75rem;
    padding: 1rem 0.5rem;
  }

  .users-table tbody td {
    font-size: 0.75rem;
    padding: 0.75rem 0.5rem;
  }

  .role {
    font-size: 0.625rem;
    padding: 0.25rem 0.5rem;
  }
}

/* Animations pour les interactions */
.users-table tbody tr,
.users-btn-add,
.users-modal-actions button,
.users-filters input,
.users-filters select {
  will-change: transform;
}

/* Scrollbar personnalisée pour la modal */
.users-modal::-webkit-scrollbar {
  width: 6px;
}

.users-modal::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.users-modal::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.users-modal::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* États de chargement */
.users-table tbody tr.loading {
  opacity: 0.6;
  pointer-events: none;
}

/* Focus visible pour l'accessibilité */
.users-btn-add:focus-visible,
.users-modal-actions button:focus-visible,
.users-filters input:focus-visible,
.users-filters select:focus-visible {
  outline: 2px solid #7c3aed;
  outline-offset: 2px;
}

/* Amélioration de l'accessibilité */
.users-btn-edit:focus,
.users-btn-delete:focus {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}

/* Style pour les messages d'erreur (prêt à utiliser) */
.users-error-message {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border-left: 4px solid #ef4444;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}

/* Style pour les messages de succès (prêt à utiliser) */
.users-success-message {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border-left: 4px solid #10b981;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}

/* Effet de survol sur les rôles */
.users-table tbody tr:hover .role.admin {
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.4);
  transform: scale(1.05);
}

.users-table tbody tr:hover .role.tech {
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
  transform: scale(1.05);
}

/* Animation des boutons d'action */
.users-btn-edit,
.users-btn-delete {
  position: relative;
  overflow: hidden;
}

.users-btn-edit::before,
.users-btn-delete::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: currentColor;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.3s ease, height 0.3s ease;
  opacity: 0.1;
  z-index: -1;
}

.users-btn-edit:hover::before,
.users-btn-delete:hover::before {
  width: 100%;
  height: 100%;
}

/* Style spécial pour l'email */
.users-table tbody td:nth-child(5) {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 0.8rem;
  color: #6366f1;
}

/* Style spécial pour le téléphone */
.users-table tbody td:nth-child(4) {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-weight: 500;
}

/* Indicateur de rôle dans le titre */
.users-page h1::after {
  content: "👥";
  margin-left: 1rem;
  font-size: 2rem;
  vertical-align: middle;
}

/* Animation de pulsation pour les nouveaux utilisateurs */
@keyframes user-highlight {
  0% {
    background: rgba(124, 58, 237, 0.1);
  }
  100% {
    background: transparent;
  }
}

.users-table tbody tr.new-user {
  animation: user-highlight 2s ease-out;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Users.css"],"names":[],"mappings":"AAAA,0FAA0F;AAC1F;EACE,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,0EAA0E;EAC1E,uFAAuF;AACzF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,6DAA6D;AAC/D;;AAEA,eAAe;AACf;EACE;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,SAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA,qCAAqC;AACrC;;;;;EAKE,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,uCAAuC;AACvC;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;;EAEE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,gCAAgC;EAChC,6CAA6C;EAC7C,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,wDAAwD;EACxD,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA,0DAA0D;AAC1D;EACE;IACE,mCAAmC;EACrC;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":["/* Container principal avec marge pour la sidebar - Cohérence avec les autres interfaces */\n.users-page {\n  /* margin-left: 230px; */\n  padding: 2rem;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 50%, #f5f7fa 100%);\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.users-page h1 {\n  color: #1e293b;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 50%, #3b82f6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Header avec filtres et bouton d'ajout */\n.users-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.users-filters {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.users-filters select,\n.users-filters input {\n  padding: 0.75rem 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 0.875rem;\n  background: white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  min-width: 140px;\n}\n\n.users-filters input {\n  min-width: 200px;\n}\n\n.users-filters select:focus,\n.users-filters input:focus {\n  outline: none;\n  border-color: #7c3aed;\n  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);\n  transform: translateY(-1px);\n}\n\n.users-filters input::placeholder {\n  color: #94a3b8;\n}\n\n/* Bouton d'ajout */\n.users-btn-add {\n  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%);\n  color: white;\n  border: none;\n  padding: 0.875rem 1.5rem;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);\n  white-space: nowrap;\n}\n\n.users-btn-add:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(124, 58, 237, 0.4);\n}\n\n.users-btn-add:active {\n  transform: translateY(0);\n}\n\n/* Tableau */\n.users-table {\n  width: 100%;\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  border-collapse: collapse;\n}\n\n.users-table thead {\n  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 50%, #8b5cf6 100%);\n}\n\n.users-table thead th {\n  padding: 1.25rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: white;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.users-table tbody tr {\n  border-bottom: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n}\n\n.users-table tbody tr:hover {\n  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);\n  transform: scale(1.005);\n}\n\n.users-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.users-table tbody td {\n  padding: 3px;\n  color: #374151;\n  font-size: 0.875rem;\n  vertical-align: middle;\n}\n\n/* Styles pour les rôles */\n.role {\n  padding: 0.375rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  display: inline-block;\n  transition: all 0.2s ease;\n}\n\n.role.admin {\n  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%);\n  color: white;\n  box-shadow: 0 2px 8px rgba(124, 58, 237, 0.3);\n}\n\n.role.tech {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);\n}\n\n/* Boutons d'action */\n.users-btn-edit,\n.users-btn-delete {\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #6b7280;\n  margin: 0 0.25rem;\n}\n\n.users-btn-edit:hover {\n  background: #dbeafe;\n  color: #3b82f6;\n  transform: scale(1.1);\n}\n\n.users-btn-delete:hover {\n  background: #fee2e2;\n  color: #ef4444;\n  transform: scale(1.1);\n}\n\n/* Modal overlay */\n.users-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n  animation: users-modal-fade-in 0.3s ease;\n}\n\n@keyframes users-modal-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal */\n.users-modal {\n  background: white;\n  border-radius: 20px;\n  padding: 2rem;\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n  animation: users-modal-slide-up 0.3s ease;\n}\n\n@keyframes users-modal-slide-up {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.users-modal h2 {\n  color: #1e293b;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 50%, #3b82f6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Formulaire modal */\n.users-modal form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.users-modal input,\n.users-modal select {\n  padding: 0.875rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 10px;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.users-modal input:focus,\n.users-modal select:focus {\n  outline: none;\n  border-color: #7c3aed;\n  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);\n  transform: translateY(-1px);\n}\n\n.users-modal input::placeholder {\n  color: #9ca3af;\n}\n\n/* Actions de modal */\n.users-modal-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.users-modal-actions button {\n  padding: 0.875rem 1.5rem;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  flex: 1;\n}\n\n.users-modal-actions button[type=\"submit\"] {\n  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);\n}\n\n.users-modal-actions button[type=\"submit\"]:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(124, 58, 237, 0.4);\n}\n\n.users-modal-actions button[type=\"button\"] {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.users-modal-actions button[type=\"button\"]:hover {\n  background: #e5e7eb;\n  transform: translateY(-1px);\n}\n\n/* Message \"Aucun utilisateur trouvé\" */\n.users-table tbody td[colspan=\"6\"] {\n  text-align: center;\n  color: #6b7280;\n  font-style: italic;\n  padding: 2rem;\n  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .users-page {\n    margin-left: 0;\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .users-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .users-filters {\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  .users-filters select,\n  .users-filters input {\n    min-width: auto;\n    flex: 1;\n  }\n\n  .users-table {\n    font-size: 0.75rem;\n  }\n\n  .users-table thead th,\n  .users-table tbody td {\n    padding: 0.75rem 0.5rem;\n  }\n\n  .users-modal {\n    padding: 1.5rem;\n    margin: 1rem;\n  }\n\n  .users-modal-actions {\n    flex-direction: column;\n  }\n\n  .users-modal-actions button {\n    flex: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .users-page h1 {\n    font-size: 2rem;\n  }\n\n  .users-table thead th {\n    font-size: 0.75rem;\n    padding: 1rem 0.5rem;\n  }\n\n  .users-table tbody td {\n    font-size: 0.75rem;\n    padding: 0.75rem 0.5rem;\n  }\n\n  .role {\n    font-size: 0.625rem;\n    padding: 0.25rem 0.5rem;\n  }\n}\n\n/* Animations pour les interactions */\n.users-table tbody tr,\n.users-btn-add,\n.users-modal-actions button,\n.users-filters input,\n.users-filters select {\n  will-change: transform;\n}\n\n/* Scrollbar personnalisée pour la modal */\n.users-modal::-webkit-scrollbar {\n  width: 6px;\n}\n\n.users-modal::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.users-modal::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.users-modal::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* États de chargement */\n.users-table tbody tr.loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n/* Focus visible pour l'accessibilité */\n.users-btn-add:focus-visible,\n.users-modal-actions button:focus-visible,\n.users-filters input:focus-visible,\n.users-filters select:focus-visible {\n  outline: 2px solid #7c3aed;\n  outline-offset: 2px;\n}\n\n/* Amélioration de l'accessibilité */\n.users-btn-edit:focus,\n.users-btn-delete:focus {\n  outline: 2px solid currentColor;\n  outline-offset: 2px;\n}\n\n/* Style pour les messages d'erreur (prêt à utiliser) */\n.users-error-message {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  color: #dc2626;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  border-left: 4px solid #ef4444;\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n}\n\n/* Style pour les messages de succès (prêt à utiliser) */\n.users-success-message {\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  color: #059669;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  border-left: 4px solid #10b981;\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n}\n\n/* Effet de survol sur les rôles */\n.users-table tbody tr:hover .role.admin {\n  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.4);\n  transform: scale(1.05);\n}\n\n.users-table tbody tr:hover .role.tech {\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);\n  transform: scale(1.05);\n}\n\n/* Animation des boutons d'action */\n.users-btn-edit,\n.users-btn-delete {\n  position: relative;\n  overflow: hidden;\n}\n\n.users-btn-edit::before,\n.users-btn-delete::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  background: currentColor;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  transition: width 0.3s ease, height 0.3s ease;\n  opacity: 0.1;\n  z-index: -1;\n}\n\n.users-btn-edit:hover::before,\n.users-btn-delete:hover::before {\n  width: 100%;\n  height: 100%;\n}\n\n/* Style spécial pour l'email */\n.users-table tbody td:nth-child(5) {\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  font-size: 0.8rem;\n  color: #6366f1;\n}\n\n/* Style spécial pour le téléphone */\n.users-table tbody td:nth-child(4) {\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  font-weight: 500;\n}\n\n/* Indicateur de rôle dans le titre */\n.users-page h1::after {\n  content: \"👥\";\n  margin-left: 1rem;\n  font-size: 2rem;\n  vertical-align: middle;\n}\n\n/* Animation de pulsation pour les nouveaux utilisateurs */\n@keyframes user-highlight {\n  0% {\n    background: rgba(124, 58, 237, 0.1);\n  }\n  100% {\n    background: transparent;\n  }\n}\n\n.users-table tbody tr.new-user {\n  animation: user-highlight 2s ease-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
